"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClassroomParticipantRoleEnum = void 0;
/** Роль участника классной комнаты */
var ClassroomParticipantRoleEnum;
(function (ClassroomParticipantRoleEnum) {
  /** Учащийся */
  ClassroomParticipantRoleEnum[ClassroomParticipantRoleEnum["student"] = 10] = "student";
  /** Приглашённый (впоследствии - учащийся) */
  ClassroomParticipantRoleEnum[ClassroomParticipantRoleEnum["invitee"] = 20] = "invitee";
  /** Преподаватель */
  ClassroomParticipantRoleEnum[ClassroomParticipantRoleEnum["teacher"] = 50] = "teacher";
  /** Преподаватель на замену */
  ClassroomParticipantRoleEnum[ClassroomParticipantRoleEnum["replacement_teacher"] = 60] = "replacement_teacher";
  /** Помощник в управлении классом */
  ClassroomParticipantRoleEnum[ClassroomParticipantRoleEnum["assistant"] = 70] = "assistant";
  /** Владелец */
  ClassroomParticipantRoleEnum[ClassroomParticipantRoleEnum["owner"] = 100] = "owner";
})(ClassroomParticipantRoleEnum = exports.ClassroomParticipantRoleEnum || (exports.ClassroomParticipantRoleEnum = {}));
